<script>
    export let visible;
    export let onCloseCallback;
    let internalLinks = [
        "about",
        "skills",
        "experience",
        // "projects",
        // "journal",
        "contact"
    ];

    function onClose() {
        setTimeout(onCloseCallback, 600);
    }
</script>

<div id="menu-panel" class:visible>
    <nav>
        <ul>
            {#each internalLinks as link}
            <li class="internal">
                <a href="{'#' + link}" on:click={onClose}>{link}</a>
            </li>
            {/each}
        </ul>
    </nav>
</div>

<style>
    #menu-panel {
        position: fixed;
        right: 0;
        top: 0;
        height: 100%;
        background-color: #2E2828;
        color: #FFF5E6;
        transition-property: margin-right;
        transition-duration: 0.6s;
        font-family: 'Reem Kufi', sans-serif;
        font-size:36px;
        letter-spacing: -2px;
    }
    #menu-panel.visible {
        display: inline-block;
        margin-right:0;
    }
    #menu-panel ul {
        padding-left: 0;
        margin-top: 100px;
    }
    #menu-panel li {
        list-style: none;
        text-transform: uppercase;
        margin: 0 40px;
    }
    #menu-panel li:hover::before {
        visibility: visible;
    }
    #menu-panel li::before {
        font-size:28px;
        vertical-align: middle;
        margin-right: 10px;
        visibility: hidden;
    }
    #menu-panel li.internal::before {
        content: "#";
    }
    #menu-panel li.external::before {
        content: "⬏";
    }
    li a {
        color: #FFF5E6;
        text-decoration: none;
    }
</style>